import { Injectable } from "@angular/core";
import { APIService } from "../api";
import {BehaviorSubject, Observable, Subscription, tap} from "rxjs";
import {
  KPI,
  QuotePartUpdatePayload,
  QuotePartItem,
  QuotePartPermission,
  QuotePartDeleteResponse,
  QuotePartCreateResponse,
  QuotePartUpdateResponse,
  PerimeterTypes,
  AssociatedPerimeters, QuotePartCreatePayload,
  EnableValue
} from "../api/models";

@Injectable()
export class QuotePartService {

    private readonly _quoteparts = new BehaviorSubject<QuotePartItem[]>([]);
    quoteparts$ = this._quoteparts.asObservable();

    constructor(
      private api: APIService
    ) { }

    public getQuoteParts(): Subscription {
      return this.api.get_quote_parts().pipe(
        tap(qps => this._quoteparts.next(qps))
      ).subscribe()
    }
    public getQuotePartDetail(quotePartId: number): Observable<QuotePartItem> {
      return this.api.get_quote_part_by_id(quotePartId);
    }
    public getAssociatedPermiterTypes(siteId: number): Observable<PerimeterTypes> {
      return this.api.get_associated_perimeter_types(siteId);
    }
    public getAssociatedPerimeters(siteId: number): Observable<AssociatedPerimeters> {
      return this.api.get_associated_perimeters(siteId);
    }
    public getAvailablePermiterTypes(): Observable<KPI.PerimeterType[]> {
      return this.api.structures_perimeter_types();
    }
    public updateQuotePart(id: number, payload: QuotePartUpdatePayload): Observable<QuotePartUpdateResponse> {
      return this.api.patch_quote_parts_update(id, payload);
    }
    public createQuotePart(payload: QuotePartCreatePayload): Observable<QuotePartCreateResponse> {
      return this.api.post_quote_parts_create(payload);
    }
    public getQuotePartPermission(): Observable<QuotePartPermission> {
      return this.api.get_quote_part_permission();
    }
    public getQuotePartBySiteId(siteId: number): Observable<QuotePartItem[]> {
      return this.api.get_quote_parts_by_site(siteId);
    }
    public getQuotePartEnabled(): Observable<EnableValue> {
      return this.api.get_quote_parts_module_enabled();
    }
    //delete quote part
    public deleteQuotePart(id: number): Observable<QuotePartDeleteResponse> {
      return this.api.delete_quote_part(id);
    }
    // update "Other" investment quotepart
    // this method can be created OR update, so we use post
    public updateOrCreateQuotePartTypeOther(investmentId: number, payload: QuotePartUpdatePayload): Observable<QuotePartUpdateResponse> {
      return this.api.post_other_investment_quote_part(investmentId,payload) as any;
    }
}
